module.exports = __webpack_public_path__ + "static/media/checklist.6d6b9d5c.svg";